import { onBookkeepingActivity } from "common/signalR";
import ActivityPanel from "components/ActivityPanel/ActivityPanel";
import React from "react";
import { BookkeepingActivityCard } from "./BookkeepingActivityCard";

interface Props {
  bookkeepingId: number
  config: server.dto.ActivityPanelConfig
}

export const BookkeepingActivityPanel = (props: Props) => {
  return <ActivityPanel<server.dto.BookkeepingActivity>
    config={props.config}
    fetchActivities={(page, perPage) => window.CoreApi.Bookkeeping.ListActivity({ itemId: props.bookkeepingId, page, perPage })}
    renderActivity={(activity => <BookkeepingActivityCard key={activity.activityId} activity={activity} />)}
    onActivityRegisterFn={onBookkeepingActivity}
    onActivity={(activity) => {
      if (activity.itemId !== props.bookkeepingId) return { refreshActivities: false };

      const iAmActor = (activity.actor?.userId === site.currentUser.userId);

      return { refreshActivities: iAmActor };
    }}
  />
}